module.exports = __webpack_public_path__ + "static/rs-banner-transparent-13d0c187b8b0005aabd8919474dace98.png";